import { AppService } from "src/app/_services/app.service";
import { Component, OnInit } from "@angular/core";
import { MonnaieService } from "src/app/_services/monnaie.service";
import { Browser } from "@capacitor/browser";

@Component({
  selector: "app-bank-link",
  templateUrl: "./bank-link.component.html",
  styleUrls: ["./bank-link.component.scss"],
  standalone: false,
})
export class BankLinkComponent implements OnInit {
  constructor(
    private monnaieService: MonnaieService,
    private appService: AppService
  ) {}
  isLoading: boolean = false;
  ngOnInit() {}
  closeModal(){
    this.appService.dispatchModal("BANK_LINK_MODAL",false)
  }
  getActivateBankLink() {
    this.isLoading = true;
    this.monnaieService.getAccountLinkingUrl().subscribe((res: any) => {
      let url = res.body.url;
      this.appService.openUrl(url).then(() => {
        this.isLoading = false;
        this.appService.dispatchModal("BANK_LINK_MODAL", false);
      });
    });
  }
}
